import React from "react";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import SFCheckbox from "../../../checkbox";
import getStyled from "../../../../hooks/getStyled";

const { styled } = getStyled();

const PaperStyled = styled(Paper)(({ theme }) => ({
  width: "240px",
  borderRadius: "0px 0px 4px 4px",
  borderRight: `1px solid ${theme.palette.grey250.main}`,
  borderBottom: `1px solid ${theme.palette.grey250.main}`,
  borderLeft: `1px solid ${theme.palette.grey250.main}`,
  boxShadow: "0px 3px 9px 0px rgba(183, 183, 183, 0.10)",
}));

const MenuItemStyled = styled(MenuItem)(() => ({
  height: "30px",
}));

const ActionBarSearchInputMenuItem = ({ label, onClick, checked }) => {
  return (
    <MenuItemStyled onClick={onClick}>
      <SFCheckbox checked={checked} label={label} />
    </MenuItemStyled>
  );
};

const ActionBarSearchInputMenu = ({
  open,
  options,
  selectedOptions,
  onOptionClick,
  anchorEl,
}) => {
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      role={undefined}
      placement="bottom-start"
      transition
      disablePortal
      sx={{ zIndex: 1000 }}
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin:
              placement === "bottom-start" ? "left top" : "left bottom",
          }}
        >
          <PaperStyled>
            <MenuList
              autoFocusItem={open}
              id="search-menu"
              aria-labelledby="search-button"
              disablePadding
            >
              {options.map((item, index) => (
                <ActionBarSearchInputMenuItem
                  key={index}
                  label={item}
                  onClick={() => onOptionClick(index)}
                  checked={selectedOptions.includes(options[index])}
                />
              ))}
            </MenuList>
          </PaperStyled>
        </Grow>
      )}
    </Popper>
  );
};

export default ActionBarSearchInputMenu;
